export const shortenAddress = (address: string, chars = 4): string => {
  if (!address) return '';
  return `${address.slice(0, chars + 2)}...${address.slice(-chars)}`;
};

export const getLastFourChars = (address: string): string => {
  if (!address) return '';
  return address.slice(-4);
};

export const formatCreatorAddress = (address: string): string => {
  if (!address) return '';
  return `0x...${address.slice(-4)}`;
};

// Subscript digits for price formatting
const subscriptDigits: { [key: string]: string } = {
  '0': '₀', '1': '₁', '2': '₂', '3': '₃', '4': '₄',
  '5': '₅', '6': '₆', '7': '₇', '8': '₈', '9': '₉'
};

export const formatPriceWithSubscript = (price: number | string): string => {
  const numPrice = typeof price === 'string' ? parseFloat(price) : price;
  
  if (isNaN(numPrice) || numPrice === 0) return '$0.00';
  
  // For prices >= 0.01, use normal formatting
  if (numPrice >= 0.01) {
    return `$${numPrice.toFixed(2)}`;
  }
  
  // For very small prices, use subscript notation
  const priceStr = numPrice.toFixed(20); // Get enough decimal places
  const match = priceStr.match(/^0\.0*([1-9]\d*)/);
  
  if (match) {
    const zeros = priceStr.indexOf(match[1]) - 2; // Number of zeros after decimal
    const significantDigits = match[1];
    
    if (zeros >= 3) {
      // Use subscript notation for 3+ leading zeros
      const subscriptZeros = zeros.toString().split('').map(d => subscriptDigits[d]).join('');
      return `$0.0${subscriptZeros}${significantDigits.slice(0, 2)}`;
    }
  }
  
  // Fallback to normal formatting for edge cases
  return `$${numPrice.toFixed(6)}`;
};

// Market cap formatting function
export const formatMarketCap = (price: number | string): string => {
  const numPrice = typeof price === 'string' ? parseFloat(price) : price;
  
  if (isNaN(numPrice) || numPrice === 0) return '$0';
  
  // All tokens have 1 billion supply, so multiply price by 1B
  const marketCap = numPrice * 1000000000; // 1 billion
  
  // Format based on size
  if (marketCap >= 1000000000) {
    // Billions
    return `$${(marketCap / 1000000000).toFixed(1)}B`;
  } else if (marketCap >= 1000000) {
    // Millions
    return `$${(marketCap / 1000000).toFixed(1)}M`;
  } else if (marketCap >= 1000) {
    // Thousands
    return `$${(marketCap / 1000).toFixed(0)}K`;
  } else {
    // Less than 1K
    return `$${marketCap.toFixed(0)}`;
  }
};